import { FiberManualRecord } from '@mui/icons-material'
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  styled
} from '@mui/material'
import { FC, ReactNode } from 'react'
import { Trans, useTranslation } from 'react-i18next'

const StyledList = styled(List)`
  padding: unset;
`

const StyledListItem = styled(ListItem)`
  gap: 6px;
  padding: unset;
`

const StyledListItemIcon = styled(ListItemIcon)`
  align-self: flex-start;
  color: white;
  margin-top: 4px;
  min-width: unset;
`

const StyledListItemText = styled(ListItemText)`
  margin: unset;
  ${props => props.theme.breakpoints.down('res1024')} {
    max-width: 200px;
  }
`

const BulletIcon = styled(FiberManualRecord)`
  font-size: 12px;
`

const ApeironI18nListItem: FC<ItemProps> = props => {
  const { bullet, children, className } = props

  return (
    <StyledListItem className={className}>
      <StyledListItemIcon>
        {bullet || <BulletIcon className='Custom-Bullet-Icon' />}
      </StyledListItemIcon>
      <StyledListItemText>{children}</StyledListItemText>
    </StyledListItem>
  )
}

const ApeironI18nList: FC<Props> = props => {
  const { bullet, className, componentKey = 'li', textKey } = props

  const { t } = useTranslation()

  return (
    <StyledList className={className}>
      <Trans
        components={{
          [componentKey]: <ApeironI18nListItem bullet={bullet} />
        }}
      >
        {t(textKey)}
      </Trans>
    </StyledList>
  )
}

type ItemProps = {
  bullet?: ReactNode
  children?: ReactNode
  className?: string
}

type Props = {
  bullet?: ReactNode
  className?: string
  componentKey?: string
  textKey: string
}

export default ApeironI18nList
